import { Link } from 'react-router-dom';
import { Lock, Sparkles } from 'lucide-react';

/**
 * Wraps a core dashboard tab so that, for unpaid/no-plan clients, the real
 * UI renders behind a soft blur with a centered "Choose a plan" overlay.
 *
 * Add-ons are intentionally NOT wrapped with this - they have their own
 * paywalls (Website Creation, Social Media, Paid Ads, AI Video) and Legal
 * Translations stays fully active.
 */
export default function LockedPreview({ active, children }) {
  if (!active) return children;
  return (
    <div className="relative" data-testid="locked-preview-root">
      {/* Real content rendered but blurred + non-interactive */}
      <div
        className="pointer-events-none select-none"
        style={{ filter: 'blur(6px)' }}
        aria-hidden="true"
        data-testid="locked-preview-blurred"
      >
        {children}
      </div>

      {/* Sticky upgrade overlay - stays visible while the user scrolls the
          blurred preview underneath. Pinned near the top of the dashboard
          main scroll container. */}
      <div
        className="absolute inset-0 pointer-events-none"
        data-testid="locked-preview-overlay"
      >
        <div className="sticky top-8 flex justify-center pointer-events-none px-4">
          <div className="max-w-md w-full bg-white/95 backdrop-blur-xl rounded-3xl border border-violet-200 shadow-2xl shadow-violet-500/30 p-8 text-center pointer-events-auto">
            <div className="w-14 h-14 mx-auto rounded-2xl bg-gradient-to-br from-violet-600 to-indigo-600 flex items-center justify-center shadow-lg shadow-violet-500/40">
              <Lock className="w-6 h-6 text-white" />
            </div>
            <h3
              className="text-2xl font-bold text-slate-900 mt-5"
              style={{ fontFamily: 'Outfit' }}
            >
              Choose a plan to unlock your dashboard
            </h3>
            <p className="text-sm text-slate-500 mt-2 leading-relaxed">
              Pick any core plan to start receiving live SEO, content, link-building, and reporting work from our team.
            </p>
            <Link
              to="/plan-selection"
              className="mt-6 inline-flex items-center justify-center gap-2 px-6 py-3 rounded-xl bg-gradient-to-r from-violet-600 to-indigo-600 text-white font-bold text-sm shadow-lg shadow-violet-600/40 hover:shadow-violet-600/60 hover:scale-[1.02] transition-all"
              data-testid="locked-preview-cta"
            >
              <Sparkles className="w-4 h-4" />
              Choose a plan
            </Link>
            <p className="text-xs text-slate-400 mt-4">
              Add-ons (Website, Social Media, Paid Ads, AI Video, Legal Translations) remain available independently.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
